import { Box, Drawer, Icon, IconButton, ThemeProvider, Tooltip } from "@mui/material";
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { TitleText } from "~/components/Typographies";
import { useAppDispatch, useAppSelector } from "~/hooks/reduxHooks";
import AppThemeContext from "~/providers/AppThemeContext";
import { closeProfilePanel, PROFILE_PANEL_WIDTH } from "~/store/layoutSlice";
import { themeCreator } from "~/themes/pageThemes";
import Profile from "~settings/profile";

const ProfilePanel = () => {
	const { t } = useTranslation("common");
	const dispatch = useAppDispatch();
	const open = useAppSelector((state) => state.layout.profilePanelOpen);
	const { themeSize, themeType } = useContext(AppThemeContext);
	const worksuiteTheme = useMemo(() => themeCreator("worksuite", themeType, themeSize), [themeType, themeSize]);
	const close = () => dispatch(closeProfilePanel());

	return (
		<ThemeProvider theme={worksuiteTheme}>
			<Drawer
				PaperProps={{
					sx: {
						display: "flex",
						flexDirection: "column",
						width: { sm: PROFILE_PANEL_WIDTH, xs: "100vw" }
					}
				}}
				anchor="right"
				onClose={close}
				open={open}
				sx={{ zIndex: (theme) => theme.zIndex.modal }}
			>
				<Box
					sx={{
						alignItems: "center",
						borderBottom: 1,
						borderBottomColor: "divider",
						display: "flex",
						flexShrink: 0,
						gap: 1,
						pl: 2,
						pr: 1,
						py: 1
					}}
				>
					<TitleText bold>{t("shell.profilePanel.title")}</TitleText>
					<Box sx={{ flex: 1 }} />
					<Tooltip title={t("actions.close")}>
						<IconButton aria-label={t("shell.profilePanel.closeAria")} onClick={close} size="small">
							<Icon>close</Icon>
						</IconButton>
					</Tooltip>
				</Box>
				<Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
					<Profile hosted />
				</Box>
			</Drawer>
		</ThemeProvider>
	);
};

export default ProfilePanel;
